import { useEffect } from 'react';
import { string, oneOf, func } from 'prop-types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function NotificationToast({toastId, message, kind, onClose}) {

  useEffect(() => {
    if(message) {
      toast(message, {
        toastId,
        type: kind,
        autoClose: kind !== 'error',
        onClose: onClose,
      });
    }
  }, [message, kind]);

  return null;
}

NotificationToast.propTypes = {
  toastId: string.isRequired,
  message: string,
  kind: oneOf(['success', 'error']),
  onClose: func,
}

NotificationToast.defaultProps = {
  message: undefined,
  kind: 'success',
  onClose: undefined,
}

export default NotificationToast;